import { render, staticRenderFns } from "./UserChart.vue?vue&type=template&id=63f8834a&scoped=true"
import script from "./UserChart.vue?vue&type=script&lang=js"
export * from "./UserChart.vue?vue&type=script&lang=js"
import style0 from "./UserChart.vue?vue&type=style&index=0&id=63f8834a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f8834a",
  null
  
)

export default component.exports